export default {
  title: 'Referral Program',
  subtitle: 'Available for: <span>Online Widget</span>',
  description:
    'Reward members when they invite others to sign up and join your Loyalty Rewards Program.',
  emptyState: {
    title: 'It’s time to put word of mouth on blast',
    description: `With your new referral program, members earn Coins when they invite people to buy from your business. It’s that simple.`,
    button: 'Create your Referral Program',
    buttonUpgrade: 'Upgrade & Create your Referral Program',
    learnMore: 'Learn more about Referral Program'
  },
  creation: {
    'step-1': {
      disclaimer:
        'Not to worry, you can edit your referral campaign settings later.',
      button: 'Continue',
      buttonMobile: 'Continue',
      both: {
        title: 'Both members will earn a Loyalty Reward',
        description:
          'The referring member and the person who joins will both get rewards ONLY after a purchase is made.'
      },
      referring: {
        title: 'Only referring members will earn a Loyalty Reward',
        description:
          'Members that share a referral link will receive a reward ONLY after someone joins and makes their first purchase. Referring members ONLY.'
      },
      referred: {
        title: 'Only new members will earn a Loyalty Reward',
        description:
          'New members will receive a reward after sign up. No purchase required.'
      }
    },
    'step-2': {
      back: 'Back',
      button: 'Create referral program',
      buttonMobile: 'Continue',
      referring: {
        title: 'Members that refer others',
        description:
          'Members will get a reward after someone joins your Loyalty Rewards Program AND makes a purchase.',
        labelInput: 'Loyalty Coins Amount'
      },
      referred: {
        title: 'Who receives the link',
        description:
          'The person invited to your Loyalty Rewards Program will receive their reward just after they sign up.',
        labelInput: 'Reward Percentage Amount'
      },
      onlyReferred: {
        title: 'Only new members will earn a reward',
        description:
          "The person invited to your Loyalty Rewards Program will receive their reward after as soon as they've joined.",
        labelInput: 'Reward Percentage Amount'
      },
      preview: 'Reward preview',
      breadcrumbs: {
        both: 'Create your referral program: rewarding both',
        referred: 'Create your referral program: only new members will earn',
        referring:
          'Create your referral program: only referring members will earn'
      }
    },
    feedback: {
      title: 'Referral Program created successfully!',
      description: 'Your referral program is now created and active.',
      button: 'See referral program'
    }
  },
  campaign: {
    title: 'Campaign status',
    edit: 'Edit Referral Program Settings',
    type: 'Your campaign type',
    both: 'Both will receive a reward',
    referring: 'Only who invites earn a reward',
    referred: 'Only who receive a invitation earn a reward',
    referredValue: '{value}% OFF Coin'
  },
  edit: {
    button: 'Save',
    back: 'Cancel',
    change: 'Change',
    feedback: {
      activated: 'Campaign successfully activated',
      deactivated: 'Campaign successfully deactivated',
      changed: 'Campaign successfully changed'
    },
    'step-1': {
      title: 'Choose the type of referral program:',
      button: 'Continue',
      buttonMobile: 'Continue'
    },
    'step-2': {
      title: 'Referral program setup:',
      back: 'Back',
      button: 'Save referral program',
      buttonMobile: 'Continue',
      breadcrumbs: {
        both: 'Edit your referral program: rewarding both',
        referred: 'Edit your referral program: only new members will earn',
        referring:
          'Edit your referral program: only referring members will earn'
      }
    }
  },
  statistics: {
    title: 'Referral Program Performance - since {since}',
    joined: 'Joined',
    purchase: 'Made a purchase',
    category: 'New Members'
  }
};
